<template>
    <rkm-area
        no-margin-top
        title="Pré-natal, parto e nascimento"
        type="section"
    >
        <rkm-row>
            <rkm-col cols="4">
                <Item
                    :get-value="() => item.preNatal.gravidezTipo.nome"
                    label="Tipo de gravidez"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.preNatal.alturaUterina"
                    append-text="cm"
                    label="Altura uterina"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.preNatal.isGravidezAltoRisco ? 'Alto' : 'Habitual'"
                    label="Risco da gravidez"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.preNatal.edema.nome"
                    label="Edema"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.preNatal.movimentacaoFetal ? 'Sim' : 'Não'"
                    label="Movimentação fetal"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.preNatal.gravidezPlanejada ? 'Sim' : 'Não'"
                    label="Gravidez planejada"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <Item
                    :get-value="() => item.preNatal.batimentoCardiacoFetal"
                    append-text="bpm"
                    label="Batimento cardíaco fetal"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!item.preNatal.isPrimeiroAtendimento">
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.objetivo.dum"
                    label="DUM"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.preNatal.dpp"
                    label="DPP"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>